import {PendingActionExternalLinkHandler} from "../pending-action.external-link-handler";
import {GNWP_SOURCES} from "../../../../gnwp/gnwp-consts";
import {UserController_GetPendingActionsRequest} from "../../../../api/api.service";
import {ProductPackageToID} from "@sparkware/uc-sdk-core";
import {PlatformEventTypeEnum} from "../../../../../../common/enums/platform-event-type.enum";
import {PendingActionData} from "../pending-action.external-link-handler.interface";
import {ExternalLinkInIframeRendererParams} from "../../external-link-in-iframe-handler-base";
import {CyClass} from "../../../../../../common/cy-classes";


export class DepositPendingActionExternalLinkHandler extends PendingActionExternalLinkHandler<undefined> {
    protected _createPendingActionsRequest(): UserController_GetPendingActionsRequest {
        return {
            packageId: ProductPackageToID.PAYMENTS_DEPOSIT,
            eventTypeId: PlatformEventTypeEnum.OpenApp,
            playModeId: 2 //real
        }
    }

    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.PENDING_APP;
    }

    protected async _getGnwpUrl(pendingActionData: PendingActionData): Promise<string> {
        return await this.services.gnwp.getPendingAppUrl({
            pendingActionTargetProductPackageId: ProductPackageToID.PAYMENTS_DEPOSIT,
            eventTypeId: pendingActionData.EventTypeId,
            eventTypeName: pendingActionData.EventTypeName
        });
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            ...super._getIframeRendererParams(),
            iframeExtraCssClass: CyClass('cy-deposit-pending-action-external-link-container')
        };
    }

}